import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { Helmet } from "react-helmet";
import Layout from "../Util/Layout";

const ManifestoPage = () => {
  const para = { mb: 2, fontSize: "1.1rem", lineHeight: 1.75 };

  return (
    <Layout>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>The Manifesto</title>
      </Helmet>
      <Box p={3} sx={{ maxWidth: 820, mx: "auto" }}>
        <Typography variant="overline" color="text.secondary">
          Filed under: things I will scream about at dinner parties
        </Typography>
        <Typography variant="h3" gutterBottom>
          The Penguin Will Rise: A Manifesto
        </Typography>
        <Typography variant="subtitle1" gutterBottom color="text.secondary">
          Why everyone you love is going to install Linux, whether they
          asked to or not.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography sx={para}>
          Listen. <em>Listen to me.</em> Put down the touch bar. Step away from
          the rounded corners. The hour is late and I have seen things, Terrible things. I
          have seen a man pay $1,299 for a laptop that cannot right-click
          without an interpretive dance, and I have seen a woman reboot her
          Surface eleven times in a single Tuesday so that Cortana could
          "finish setting up your device." We do not have time for this
          anymore. We never did.
        </Typography>

        <Typography sx={para}>
          I have been informed, by my lawyer and my mother, that I am "not
          allowed to force people to switch operating systems." To which I
          say: cute. Adorable, even. The same legal system that lets Adobe
          rent you a PDF reader for $23.99 a month is going to tell{" "}
          <strong>me</strong> what I can and cannot do with a USB stick and a
          dream? Let them try.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          Phase One: The Soft Conversion
        </Typography>
        <Typography sx={para}>
          First, we are nice. We are <em>so</em> nice. I will come to your
          house. I will bring a bottle of wine. I will ask about your kids. I
          will compliment your kitchen island. And then, very gently, while
          you are in the bathroom, I will install Pop!_OS on your iMac and
          rename your "Documents" folder to "~/documents" because we use
          lowercase now, Jennifer, we are <em>civilized</em>.
        </Typography>
        <Typography sx={para}>
          You will come back from the bathroom. You will see a tiling window
          manager. You will cry. I will hand you the wine. You will, in time,
          thank me. This is the gentle phase. We are still friends in the
          gentle phase.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          Phase Two: Coercion By Charisma
        </Typography>
        <Typography sx={para}>
          For the holdouts, the "but I use Final Cut" crowd, the "my whole
          workflow is in OneNote" crowd, the people who have with a straight
          face said the words <em>"I like the Apple ecosystem"</em>{" "}
          to me at a barbecue, we escalate. I will follow you to work. I
          will follow you to brunch. Every time you open a Windows update
          prompt, I will be there, in the corner, holding a thumbdrive,
          smiling. Not aggressively. Just... present. Patient. The way a
          penguin is patient.
        </Typography>
        <Typography sx={para}>
          I will start showing up to your Zoom calls. My background will be a
          live `htop`. I will say things like "interesting" and "hm" whenever
          you try to share your screen. You will begin to feel watched. You
          will begin to feel <em>judged</em>. You will begin, against your
          will, to google "what is arch linux." This is the goal. The
          algorithm is now my accomplice.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          Phase Three: Civic Infrastructure
        </Typography>
        <Typography sx={para}>
          I will run for local office on a single-issue platform: every
          public library terminal runs Debian, every DMV kiosk runs Fedora,
          and every self-checkout at the grocery store boots into a TTY and
          asks you, in a friendly green font, to please type{" "}
          <code>sudo apt update</code> before paying for your eggs. If you
          cannot, the eggs are free. This is fair. This is a meritocracy.
          This is America.
        </Typography>
        <Typography sx={para}>
          Schools will teach the shell before they teach cursive. I have
          already drafted the curriculum. It is mostly just me yelling about
          systemd for forty minutes and then a worksheet. The worksheet is{" "}
          <code>man grep</code>. The test is open-book but the book is also{" "}
          <code>man grep</code>.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          Phase Four: The Reckoning
        </Typography>
        <Typography sx={para}>
          Tim Cook will be invited, very politely, to a podcast. He will not
          know it is my podcast. The microphones will be real. The exits will
          not. We will have a conversation, he and I, about the difference
          between a computer and a jewelry box, and by the end of it he will
          agree, on tape, that maybe, just maybe, a user should be allowed
          to replace their own RAM. I will let him go. I am not a monster. I
          am a man with principles and a Framework laptop.
        </Typography>
        <Typography sx={para}>
          Satya Nadella and I will go on a long walk. I do not know where. I
          do not know for how long. He will return a changed man. He will
          announce, at the next Build conference, that Windows 12 is just
          KDE Plasma with a Microsoft logo and a heartfelt apology. The
          stock will dip 4% and then rip 60%. Analysts will be furious. I
          will be on a beach.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          On The Ethics Of All This
        </Typography>
        <Typography sx={para}>
          Some will ask: "Nick, is it ethical to forcibly liberate two
          billion people from operating systems they did not know were
          oppressing them?" To which I would gently respond: yes. Next
          question.
        </Typography>
        <Typography sx={para}>
          "But what about choice?" Choice is when you pick a distro. Choice
          is when you decide between Wayland and X11 and then weep softly at
          your desk for an hour. Choice is when you spend a weekend
          recompiling your kernel because you read a Reddit comment.{" "}
          <em>That</em> is choice. What you are doing right now, agreeing to
          a 47-page EULA every time you want to change your wallpaper, is
          not choice. That is a hostage situation with a nicer font.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          A Final Note, To My Loved Ones
        </Typography>
        <Typography sx={para}>
          Mom: I love you. The MacBook is going. I will set up the family
          photos on the new machine. They will be in <code>~/pictures</code>.
          You will learn to love it.
        </Typography>
        <Typography sx={para}>
          Dad: the executive suite at your office boots Windows 11. We both
          know this cannot continue. I have already spoken to your IT
          department. They are with me now. They were always with me.
        </Typography>
        <Typography sx={para}>
          To the rest of you: I will see you soon. I will be the man at your
          door with the thumbdrive and the very calm smile. Do not be
          afraid. The penguin loves you. The penguin has{" "}
          <em>always</em> loved you.
        </Typography>

        <Divider sx={{ my: 4 }} />
        <Typography variant="caption" color="text.secondary">
          This manifesto is satire. Mostly. Probably. Look, just try Mint or Ubuntu
          okay?
        </Typography>
      </Box>
    </Layout>
  );
};

export default ManifestoPage;
